module.exports = __webpack_public_path__ + "img/30.4cd27ad3.jpg";